import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import FormInputs from '../../../Utils/FormInputs';

export default function AddMembership() {
    const initialInputData = {
        member_name: '',
        sales_date: '',
        price: '',
        validity: '',
        min_bill_amt: '',
        validity_period: '',
        apply_benefits: '',
        credits_applicable: '',
        branch_select: '',
    }
    const [inputData, setInputData] = useState(initialInputData);
    const handleSerAddMebspChange = (index, field, value) => {
        setInputData({ ...inputData, [field]: value });
    };
    const handleSerAddMebspSubmit = (e) => {
        e.preventDefault();
    };
    const serAddMebspRows = [
        {
            columns: [
                { size: { sm: 6, xxl: 4 }, label: 'Name', type: 'text', placeholder: 'Enter member name...', name: 'member_name', id: 'memberName', value: inputData.member_name, errormsg: '', },
                { size: { sm: 6, xxl: 4 }, label: 'Sales Date', type: 'date', placeholder: 'DD/MM/YYYY', name: 'sales_date', id: 'salesDate', value: inputData.sales_date, errormsg: '', },
                { size: { sm: 6, xxl: 4 }, label: 'Price', type: 'text', placeholder: 'Enter price...', name: 'price', id: 'price', value: inputData.price, errormsg: '', },
                {
                    size: { sm: 6, xxl: 4 }, label: 'Validity', type: 'select', name: 'validity', id: 'validity', value: inputData.validity, errormsg: '',
                    options: [
                        { value: '', label: 'Year' }, { value: '1', label: 'Month' }, { value: '2', label: 'Today' },
                        // ...branchData.map(item => ({ value: item.id, label: item.name }))
                    ],
                },
                { size: { sm: 6, xxl: 4 }, label: 'Min Bill Amt', type: 'text', placeholder: 'Enter bill amount...', name: 'min_bill_amt', id: 'minBillAmt', value: inputData.min_bill_amt, errormsg: '', },
                { size: { sm: 6, xxl: 4 }, label: 'Validity Period', type: 'text', placeholder: 'Enter validity period...', name: 'validity_period', id: 'validityPeriod', value: inputData.validity_period, errormsg: '', },
                {
                    size: { sm: 6 }, label: 'Apply Benefits', type: 'select', name: 'apply_benefits', id: 'applyBenefits', value: inputData.apply_benefits, errormsg: '',
                    options: [
                        { value: '', label: 'Same Invoice' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...branchData.map(item => ({ value: item.id, label: item.name }))
                    ],
                },
                {
                    size: { sm: 6 }, label: 'Credits Applicable?', type: 'select', name: 'credits_applicable', id: 'creditsApplicable', value: inputData.credits_applicable, errormsg: '',
                    options: [
                        { value: '', label: 'No' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...branchData.map(item => ({ value: item.id, label: item.name }))
                    ],
                },
                {
                    size: { md: 12 }, label: 'Branch', type: 'multiSelect', isMulti: 'true', placeholder: 'Select branch...', name: 'branch_select', id: 'branchSelect', value: inputData.branch_select, errormsg: '',
                    options: [
                        { value: "Test", label: "Test" },
                        { value: "Umesh bhai", label: "Umesh bhai" },
                        { value: "NSF Adajan", label: "NSF Adajan" },
                        { value: "NFS Parle Point", label: "NFS Parle Point" },
                        { value: "NFS Uniform", label: "NFS Uniform" },
                    ],
                },
            ]
        },
    ];
    const serAddMebspButtons = [
        { variant: "primary", text: "Add", onClick: handleSerAddMebspSubmit },
        { variant: "secondary", text: "Cancel", },
    ];

    return (
        <>
            <Card className='right-content-details'>
                <Card.Body>
                    <Card.Title>Add Membership</Card.Title>
                    <FormInputs Buttons={serAddMebspButtons} rows={serAddMebspRows} handleInputChange={handleSerAddMebspChange} handleSubmit={handleSerAddMebspSubmit} />
                </Card.Body>
            </Card>
        </>
    )
}
